export const SHOW_PROMOTION_MEAL_DETAILS = 'SHOW_PROMOTION_MEAL_DETAILS';
export const HIDE_PROMOTION_MEAL_DETAILS = 'HIDE_PROMOTION_MEAL_DETAILS';

export const showPromotionMealDetails = (mealId, menuSlug) => ({
  type: SHOW_PROMOTION_MEAL_DETAILS,
  mealId,
  menuSlug,
});

export const hidePromotionMealDetails = () => ({
  type: HIDE_PROMOTION_MEAL_DETAILS,
});
